import { useParams } from 'react-router'
import { CheckInState } from 'src/types'

export function useCurrentRouteStep(): CheckInState | undefined {
    const params = useParams<{ step: CheckInState }>()

    return params.step
}
